import { Component, Input } from '@angular/core';
import { LinkTarget } from 'src/app/shared/types/link-target.type';

@Component({
  selector: 'studio-popup-menu-optional-anchor',
  templateUrl: './popup-menu-optional-anchor.component.html',
  styleUrls: ['./popup-menu-optional-anchor.component.scss'],
})
export class PopupMenuOptionalAnchorComponent {
  // If href is specified, an anchor tag will be rendered around the ng-content
  // If no href is specified, the ng-content will be rendered as is
  @Input() href: string;
  @Input() target: LinkTarget = '_blank';
}
